<template>
  <div class="dialogbox">
      <b-card border-variant="info" bg-variant="default">
        <div class="vh-40 scroll">
          <b-icon icon="chat" font-scale="3" class="float-right" variant="info"></b-icon>
          <DialogWall></DialogWall>
        </div>
        <template v-slot:footer>
          <b-form @submit.prevent="addUtterance">
            <b-input-group class="mt-3">
              <b-input-group-prepend>
                <b-button variant="outline-info" v-b-modal.analysis><b-icon icon="columns" font-scale="1.3"></b-icon></b-button>
                <b-modal id="analysis" title="Dialog - Analyse" size="xl">
                  <DialogAnalysis></DialogAnalysis>
                </b-modal>
              </b-input-group-prepend>
              <b-form-input v-model="utterance" autocomplete="off"></b-form-input>
              <b-input-group-append v-if="!(dialog && dialog.utterances && dialog.utterances.length>0)">
                <b-button variant="primary" v-on:click.prevent="addUtteranceValue('Guten Tag, mein Name ist Elisa Engler. Was kann ich für Sie tun?')"><b-icon icon="power" font-scale="1.4"></b-icon></b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button variant="primary" v-on:click.prevent="addUtterance"><b-icon icon="chat-fill" font-scale="1.4"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </template>
      </b-card>
  </div>
</template>

<script>
import DialogWall from '@/components/DialogWall'
import DialogAnalysis from '@/components/DialogAnalysis'

export default {
  name: 'DialogBox',
  components: {
    DialogWall,
    DialogAnalysis
  },
  data() {
    return {
      utterance: ''
    }
  },
  methods: {
    addUtterance () {
      if( this.utterance ) {
        this.$store.dispatch('addUtterance', { 'text': this.utterance});
        this.utterance = '';
      }
    },
    addUtteranceValue (value) {
      if( value ) {
        this.$store.dispatch('addUtterance', { 'text': value});
      }
    }
  },
  computed: {
    dialog () {
      return this.$store.state.dialog;
    }
  }
}
</script>

<style scoped>

</style>
